import { TYPE_MAPPING } from 'components/UnifiedSearch/constants'

/**
 * Get the human-readable label for an opportunity type code.
 * @param typeCode - 2-letter type code (e.g., "RE", "CU", "HO")
 * @returns Human-readable label or null if not found
 */
export function getOppTypeLabel(
  typeCode: string | undefined | null
): string | null {
  if (!typeCode) return null
  return TYPE_MAPPING[typeCode] ?? null
}

interface OppTypeBadgeProps {
  /** 2-letter type code (e.g., "RE", "CU", "HO") */
  typeCode?: string | null
  /** Custom label to display (overrides typeCode lookup) */
  customLabel?: string | null
  /** Size variant */
  size?: 'sm' | 'md'
}

/**
 * Badge component for displaying opportunity/company type.
 * Supports both FirstBite company types (via typeCode) and custom companies (via customLabel).
 */
export function OppTypeBadge({
  typeCode,
  customLabel,
  size = 'sm',
}: OppTypeBadgeProps) {
  const label = customLabel ?? getOppTypeLabel(typeCode)

  if (!label) return null

  const sizeClasses =
    size === 'sm' ? 'text-xxs px-1.5 py-0.5' : 'text-xs px-2 py-0.5'

  return (
    <span
      className={`inline-block ${sizeClasses} bg-gray-100 text-gray-600 rounded font-medium`}
    >
      {label}
    </span>
  )
}
